export const AppLanguages = {
  // English: "en",
  Português: "pt",
};
